import {
  Component,
  effect,
  inject,
  input, signal
} from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ValidationErrorComponent } from 'src/app/pages/public/register/common/validation-error/validation-error.component';
import { ImagePickerComponent } from 'src/app/common/image-picker/image-picker.component';
import { ToastService } from 'src/app/services/Toast/toast.service';
import { User } from 'src/app/interfaces/user';
import { removeBackground } from '@imgly/background-removal';

@Component({
  selector: 'fae-details',
  imports: [
    ReactiveFormsModule,
    ValidationErrorComponent,
    ImagePickerComponent
],
  templateUrl: './fae-details.component.html',
  styleUrl: './fae-details.component.scss',
})
export class FaeDetailsComponent {
  // injectables
  toast = inject(ToastService);
  formBuilder = inject(FormBuilder);

  // inputs
  user = input.required<User>();
  editing = input.required<boolean>();

  // consts
  form!: FormGroup;

  // states
  isProcessing = signal<boolean>(false);

  // data
  e_signature = signal<Blob | string | undefined>(undefined);
  image = signal<string>('');

  constructor() {
    this.initForm();
    this.initEffects();
  }

  ngOnInit() {
    this.loadUser(this.user());
  }

  initForm() {
    this.form = this.formBuilder.group({
      category: [{ value: '', disabled: true }, Validators.required],
      fae_abbr: ['', [Validators.required, Validators.pattern('^[A-Z_]+$'), Validators.maxLength(50)]],
    });
  }

  initEffects() {
    effect(() => this.editing() ? this.form.controls['fae_abbr'].enable() : this.form.controls['fae_abbr'].disable())
  }

  loadUser(user: User) {
    const payload = {
      fae_abbr: user.fae_detail?.abbr || '',
      category: user.category || 'academe',
    };

    this.form.patchValue(payload);
    this.image.set(user.e_signature || '');
  }

  // utils
  onFileChange(file: File) {
    this.isProcessing.set(true);
    this.image.set(URL.createObjectURL(file));

    removeBackground(file, {
      output: {
        format: 'image/png',
      },
      device: 'gpu',
    })
      .then((blob) => {
        // replace with the final image
        this.e_signature.set(blob);
        this.image.set(URL.createObjectURL(blob));
      })
      .catch((err) => {
        this.toast.makeToast(
          'error',
          "There's a problem processing your image!",
          3000,
        );
      })
      .finally(() => this.isProcessing.set(false));
  }

  getForm() {
    return this.form;
  }
}
